import { MINCOL } from "../../../constants/const";

export const evuHeader = [
    {accessor: 'id',
    Header: 'ID'},
    {accessor: 'evu',
    Header: 'Bezeichnung',
    width: '28em'},
    {accessor: 'kurz',
    Header: 'Abkürzung',
    width: MINCOL},
];

export const evuInputs = ['evu', 'kurz'];